import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConsultarProgramasContratanteResponseModel } from '../../models/cotizador-contratante/consultar-programas-contratante/response/consultar-programas-contratante-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarProgramasContratanteService {
  private readonly URL = `${environment.HOST}${URL_MAP.API.PROGRAMAS_CONTRATANTE}`;

  constructor(private http: HttpClient) { }

  consultarProgramasContratante(idCotizacion: number | string): Observable<ConsultarProgramasContratanteResponseModel> {
    return this.http.get<ConsultarProgramasContratanteResponseModel>(this.URL, {
      params: { idCotizacion: String(idCotizacion) }
    });
  }
}
